import type { Market } from "../../domain/location/types";
import type { CalculationResult } from "../../engines/types";
import type { Dictionary } from "../../i18n";

export interface SafetyFlag {
	id: string;
	/** Already in the reader's language. */
	text: string;
}

/**
 * The flags the Safety & planning tab raises, as one list. The tab badge counts
 * it and the design panel shows it beside the controls that caused it, so the
 * two can never disagree about how many flags there are.
 *
 * Permit flags only count where permit guidance is shown (se): intl hides the
 * Swedish permit surfaces, so a badge counting them pointed at nothing.
 */
export function collectSafetyFlags(
	calcData: Pick<
		CalculationResult,
		"permit" | "roofAssembly" | "roofJoists" | "openingValidation"
	>,
	market: Market,
	t: Dictionary,
): SafetyFlag[] {
	const flags: SafetyFlag[] = [];
	const { permit } = calcData;
	if (market !== "intl" && permit && permit.status !== "ok") {
		const messages =
			permit.warningEntries?.map((entry) => entry.message) ?? permit.messages;
		messages.forEach((text, index) => {
			flags.push({ id: `permit-${index}`, text });
		});
	}
	if (
		calcData.roofAssembly?.status === "manual_review" ||
		calcData.roofJoists?.verificationRequired === true
	) {
		flags.push({ id: "roof-review", text: t.construction_roofReview });
	}
	if (calcData.openingValidation?.valid === false) {
		flags.push({ id: "openings", text: t.construction_openingInvalid });
	}
	return flags;
}
